import styled from 'styled-components';

export const StyledButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background-color: ${({ theme }) => theme.color.offWhite};
  border: 1px solid ${({ theme }) => theme.color.borderColor};
  border-radius: 15px;
  transition: background-color 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.color.offWhiteHover};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.color.offWhite};
    cursor: not-allowed;

    &:hover {
      background-color: ${({ theme }) => theme.color.offWhite};
    }
  }

  svg {
    width: 3rem;
    height: 3rem;
  }
`;
export const StyledPersonRows = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  & > * {
    flex: 1 1 50%;
    max-width: 45%;
  }

  @media (max-width: 1024px) {
    & > * {
      max-width: 100%;
    }
  }
`;
